<template>
	<div style="width:660px; height:500px;" v-on:keyup.esc="close()">
		<table class="view_tbl" border="0">
			<colgroup>
				<col style="width:90px;" />
				<col style="width:70px;" />
				<col style="width:90px;" />
				<col style="width:70px;" />
				<col style="width:100px;" />
				<col style="" />
			</colgroup>
			<tbody>
				<tr>
					<th>Receipt Date</th>
					<td><CustomDatePicker v-model="receipt_date" :disabled="cash_date_locked" /></td>
					<th>Pay Amount</th>
					<td><currency-input type="text" v-model.trim="totalReceiptAmount" :disabled="true" :precision="2" style="font-weight:bold;width:90px;" class="al_right" readonly /></td>
					<th v-if="false">
						<!-- 일단 막음. 나중에 검토할 것 0-->
						<label for="use_credit" @change="adjust()"> <input type="checkbox" id="use_credit" v-model="use_credit" :disabled="credits.length == 0" />Use Credit</label>
					</th>
					<td v-if="false">
						<!-- 일단 막음. 나중에 검토할 것 0-->
						<select v-model="selected_credit" class="tbl_select" @change="adjust()" :disabled="!use_credit">
							<option v-for="credit in credits" v-bind:value="{ sc_no: credit.sc_no, amount: credit.amount }" v-bind:key="credit.sc_no">{{ credit.amount | toCurrency }}</option>
						</select>
					</td>
				</tr>
				<tr>
					<th>Cust. Notice</th>
					<td colspan="5">
						<input type="text" class="tbl_int full_int" v-model.trim="partner.notice" style="font-weight:bold;color:red;" readonly />
					</td>
				</tr>
			</tbody>
		</table>

		<div class="view_inner">
			<table class="list_tbl2" border="0">
				<thead>
					<tr>
						<th width="21%">Payment Method</th>
						<th width="18%">Post Check Date</th>
						<th>
							<span>Check No / Info.</span>
							<input type="button" value="Apply Inv. No(s)" class="gray_bt2" @click="applyNos()" style="font-size:12px;height:24px;padding-top:1px;margin-left:1px;margin-top:-7px;" />
						</th>
						<th width="15%">Amount</th>
						<th width="10%">Add/Del</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(method, index) in receipt_methods" v-bind:key="index" v-show="method.receipt_type.code != 'CREDIT'">
						<td class="al_left">
							<select v-model="method.receipt_type" class="tbl_select" ref="receipt_type_select">
								<option v-for="receiptType in receiptTypes" v-bind:value="{ code: receiptType.code, name: receiptType.name }" v-bind:key="receiptType.code">{{ receiptType.name }}</option>
							</select>
						</td>
						<td><CustomDatePicker v-if="postCheck(method)" v-model="method.post_check_date" /></td>
						<td><input type="text" class="r_int long_type al_left" v-model="method.check_no" placeholder="Check No or Pay Info." autocomplete="off" @focus="$event.target.select()" @keydown.ctrl.enter.prevent="save()" /></td>
						<td><currency-input type="text" v-model.trim="method.amount" :precision="2" class="r_int long_type al_right" @focus="$event.target.select()" @keydown.ctrl.enter.prevent="save()" /></td>
						<td>
							<!-- <a v-if="index == receipt_methods.length - 1" href="javascript:;" type="button" class="gray_bt" @click="addMethod(method)">Add</a> -->
							<a v-if="index == receipt_methods.length - 1" href="javascript:;" type="button" class="gray_bt" @click="addMethod()">Add</a>
							<a v-else href="javascript:;" type="button" class="gray_bt" @click="delMethod(index)">Del</a>
						</td>
					</tr>
					<tr>
						<td colspan="5">
							Adj. Amt. <currency-input type="text" v-model.trim="adjusted_amount" :precision="2" class="r_int ssm_int al_right" style="width:80px;margin-right:5px;" />
							<input type="text" class="r_int long_type al_left" style="width:190px;margin-right:15px;" v-model="adjusted_amount_remark" placeholder="Remark for Adj. Amt." autocomplete="off" @focus="$event.target.select()" />
							Adj. Total <currency-input type="text" v-model.trim="amountTotal" :precision="2" class="r_int ssm_int al_right" readonly />
						</td>
						<!-- <td class="al_right">Adj. Amt.</td>
						<td colspan="2">
							<currency-input type="text" v-model.trim="adjusted_amount" :precision="2" class="r_int al_right" style="width:80px;margin-right:5px;" />
							<input type="text" class="r_int long_type al_left" style="width:190px;margin-right:15px;" v-model="adjusted_amount_remark" placeholder="Remark for Adj. Amt." autocomplete="off" @focus="$event.target.select()" />
							<span>Total</span>
						</td>
						<td><currency-input type="text" v-model.trim="amountTotal" :precision="2" class="r_int long_type al_right" readonly /></td>
						<td></td> -->
					</tr>
				</tbody>
			</table>

			<input type="text" class="r_int long_type al_left" v-model="remark" placeholder="Remark" autocomplete="off" @focus="$event.target.select()" />

			<br />

			<div class="view_bottom_bt" style="padding-top:20px;">
				<a href="javascript:;" type="button" class="search_bt" @click="save()">Save</a>
				<a href="javascript:;" type="button" class="gray_bt" @click="close()">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import '@/assets/css/table_box.css';
import { apiIndexForPayment, apiProcessPayment } from '@/api/receipt/index.js';
import { apiSelectPartnerList } from '@/api/partner/index.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { today, isDate, compareDate, dateStrDiff } from '@/utils/date.js';
import moment from 'moment-timezone';

export default {
	data: function() {
		return {
			receipt_date: today(),
			cash_time_zone: null,
			cash_receipt_code: null,
			remark: null,
			receipt_methods: [],

			receiptTypes: [],

			credits: [],

			use_credit: false,
			selected_credit: {},

			sc_amount: 0,
			adjusted_amount: 0,
			adjusted_amount_remark: null,

			first_bill_to_code: null,

			partner: {},
			// itemClass: null,
			// keyword: null,

			// allSelected: false,

			// items: [],
		};
	},
	computed: {
		cash_date_locked() {
			return this.company_id === 'jc' && this.receipt_methods.some(method => method.receipt_type.code === (this.cash_receipt_code || 'CS'));
		},
		amountTotal: {
			get: function() {
				//var sum = 0;
				// this.receipt_methods.forEach(function(method) {
				// 	if (method.amount) sum += method.amount;
				// });

				// sum += this.adjusted_amount;
				var sum = this.totalReceiptAmount + this.adjusted_amount;

				// 일단 Credit 기능 막음 if (this.use_credit && this.selected_credit.amount > 0) sum -= this.selected_credit.amount;
				sum = parseFloat(sum.toFixed(2));

				return sum;
			},
			set: function() {},
		},
		methodsTotal: {
			get: function() {
				var sum = 0;
				this.receipt_methods.forEach(function(method) {
					if (method.amount) sum += method.amount;
				});
				sum = parseFloat(sum.toFixed(2));

				return sum;
			},
			set: function() {},
		},
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},

		// toReceiveInvoices: function() {
		// 	return this.invoices.filter(invoice => invoice.selected && invoice.pay_amount);
		// },
	},
	props: {
		toReceiveInvoices: Array,
		totalReceiptAmount: Number,
	},
	components: {
		CustomDatePicker,
	},
	watch: {
		cash_date_locked(locked) {
			if (locked) this.refreshCashDate();
		},
		sc_amount: function(newValue, oldValue) {
			//console.log('data changed from ', oldValue, 'to ', newValue);
			var diff_amount = newValue - oldValue;
			this.receipt_methods[0].amount -= diff_amount;
		},
	},
	methods: {
		refreshCashDate() {
			if (!this.cash_date_locked) return true;
			if (!this.cash_receipt_code || !this.cash_time_zone || !moment.tz.zone(this.cash_time_zone)) {
				this.$toast.error('Cash receipt settings are unavailable. Reopen Process Payment.');
				return false;
			}
			this.receipt_date = moment()
				.tz(this.cash_time_zone)
				.format('MM-DD-YYYY');
			return true;
		},
		applyNos() {
			if (this.receipt_methods.length > 0) {
				if (this.user.company_id == 'beautyplus') {
					this.receipt_methods[0].check_no = this.toReceiveInvoices
						.filter(i => i.invoice_dn.startsWith('RC') || i.invoice_dn.startsWith('AR'))
						.map(i => i.invoice_dn)
						.join(' / ');

					this.remark = this.toReceiveInvoices
						.filter(i => i.invoice_dn.startsWith('BN'))
						.map(i => i.invoice_dn)
						.join(' / ');
				} else {
					this.receipt_methods[0].check_no = this.toReceiveInvoices.map(i => i.invoice_dn).join(' / ');
				}
				this.$forceUpdate();
			}
		},
		adjust() {
			if (this.use_credit && this.selected_credit.amount > 0) this.sc_amount = this.selected_credit.amount;
			else this.sc_amount = 0;
		},
		delMethod(index) {
			this.receipt_methods.splice(index, 1);
		},
		//addMethod(method) {
		addMethod() {
			//this.receipt_methods.push({ receipt_type: { code: method.receipt_type.code, name: method.receipt_type.name }, amount: this.amountTotal - this.methodsTotal });

			this.receipt_methods.push({ receipt_type: { code: null, name: '' }, amount: this.amountTotal - this.methodsTotal });
		},
		// checkNoVisible(method) {
		// 	if (method.receipt_type.name.toUpperCase().indexOf('CASH') >= 0) return false;
		// 	else return true;
		// },
		postCheck(method) {
			if (method.receipt_type.name.toUpperCase().indexOf('POST') >= 0) {
				method.post_check_yn = 'Y';
				return true;
			} else {
				method.post_check_yn = 'N';
				return false;
			}
		},
		close() {
			this.$emit('close');
		},
		hasMinusAmount() {
			// console.log(
			// 	this.adjusted_amount,
			// 	this.toReceiveInvoices.filter(i => i.pay_amount < 0),
			// );

			if (this.adjusted_amount < 0) return true;
			if (this.toReceiveInvoices.filter(i => i.pay_amount < 0).length > 0) return true;

			return false;
		},
		async adjustPostCheckDate() {
			var vm = this;
			// post check date 체크해서, 필요한 경우 년도 조정함
			//console.log(this.receipt_date);
			this.receipt_methods
				.filter(method => method.post_check_yn == 'Y')
				.forEach(m => {
					//console.log(m.post_check_date, vm.receipt_date);
					if (compareDate(m.post_check_date, vm.receipt_date) <= 0) {
						//먼저 날짜 부분 비교해서, post check date 날짜가 receipt_date 날짜 이후라면, 년도만, receipt_date 년도로 수정함, 그외는 다음해로 설정
						//console.log(m.post_check_date.substring(0, 5), vm.receipt_date.substring(0, 5), vm.receipt_date.substring(6));
						if (m.post_check_date.substring(0, 5) >= vm.receipt_date.substring(0, 5)) m.post_check_date = m.post_check_date.substring(0, 5) + '-' + vm.receipt_date.substring(6);
						else m.post_check_date = m.post_check_date.substring(0, 5) + '-' + String(Number(vm.receipt_date.substring(6)) + 1);

						vm.$toast.success('Post check date was set to ' + m.post_check_date);
					}
				});
			//console.log(this.receipt_methods.filter(method => method.post_check_yn == 'Y'));
			//return;
		},
		async save() {
			if (!this.refreshCashDate()) return;
			if (this.receipt_methods.filter(m => !m.receipt_type.code).length > 0) {
				this.$alertify.alert('Alert', 'Null payment method(s) exists.');
				return;
			}

			if (!this.receipt_date || !isDate(this.receipt_date)) {
				this.$toast.error('Invalid receipt date');
				return;
			}

			//if (this.amountTotal - this.adjusted_amount != this.totalReceiptAmount) {
			if (this.amountTotal != this.methodsTotal) {
				//console.log(this.amountTotal, this.totalReceiptAmount);
				this.$toast.error('Amounts do not match.');
				return;
			}

			if (this.hasMinusAmount() && this.receipt_methods.length > 1) {
				this.$alertify.alert('Alert', 'Payment with minus amount or minus adjust amount can not be processed with multiple payment methods.');
				return;
			}

			if (this.receipt_methods.filter(method => method.post_check_yn == 'Y').length > 1) {
				this.$alertify.alert('Alert', 'Only one post check is allowed for one payment.');
				return;
			}

			if (dateStrDiff(this.receipt_date, today()) > 30) {
				if (!confirm('The difference between the payment date and today is more than 30 days. Are you sure to proceed?')) return;
			}

			var con = true;
			var vm = this;
			var valid_receipt_date = this.receipt_date;

			this.receipt_methods.forEach(function(method) {
				if (method.post_check_yn == 'Y' && (!method.post_check_date || !isDate(method.post_check_date))) {
					vm.$toast.error('Invalid post check date');
					con = false;
				} else if (method.post_check_yn == 'Y') valid_receipt_date = method.post_check_date;

				if (method.receipt_type.name.toUpperCase().indexOf('CHECK') >= 0 && !method.check_no) {
					vm.$toast.error('Some check no is empty.');
					con = false;
				}
			});
			if (!con) return;

			if (this.use_credit && this.sc_amount > 0) this.receipt_methods.push({ receipt_type: { code: 'CREDIT', name: 'Store Credit' }, amount: this.sc_amount, sc_no: this.selected_credit.sc_no });

			if (this.receipt_methods.filter(method => method.post_check_yn == 'Y').length > 0 && this.receipt_methods.length > 1) {
				this.$toast.error('Post check is not allowed with other payment methods.');
				return;
			}

			if (this.company_id == 'newjigu' && this.receipt_methods.filter(method => method.post_check_yn == 'Y').length > 0) {
				await this.adjustPostCheckDate();

				//valid receipt date 다시 한번 체크
				this.receipt_methods.forEach(function(method) {
					valid_receipt_date = method.post_check_date;
				});
			}
			//console.log(this.receipt_methods);

			const param = {
				total_amount: this.totalReceiptAmount + this.adjusted_amount,
				receipt_date: this.receipt_date,
				valid_receipt_date: valid_receipt_date,
				receipt_methods: this.receipt_methods,
				invoices: this.toReceiveInvoices,
				remark: this.remark,
				adjusted_amount: this.adjusted_amount,
				adjusted_amount_remark: this.adjusted_amount_remark,
				invoices_json_str: JSON.stringify(this.toReceiveInvoices),
			};

			// console.log(param);
			// var dummy = 1;
			// if (dummy) return;

			const { data } = await apiProcessPayment(param);

			if (data.result) {
				this.$toast.success('Payment processed successfully');
				this.$emit('receipt-call-back', true);
				this.close();
			} else {
				this.$toast.error(data.msg);
			}
		},
		async checkBlockedPartners() {
			//console.log(this.toReceiveInvoices);
			const { data } = await apiSelectPartnerList({
				invoices: this.toReceiveInvoices,
				active_yn: 'A',
				blocked: true,
			});

			//console.log(data.partnerList, data.partnerList.length);
			if (data.partnerList.length > 0) {
				var msg = 'Payment processed successfully. Please check following customers for un-blocking.<br>';
				data.partnerList.forEach(p => {
					msg += '<br>' + p.code + ', ' + p.name;
				});
				this.$alertify.alert('Alert', msg);
			}
		},
		async init() {
			const { data } = await apiIndexForPayment({
				exclude_code: 'CREDIT',
				invoices: this.toReceiveInvoices,
				partner_code: this.first_bill_to_code,
			});

			this.cash_time_zone = data.cash_time_zone || null;
			this.cash_receipt_code = data.cash_receipt_code || null;
			this.receiptTypes = data.receiptTypeList;
			//console.log(this.receiptTypes);
			this.credits = data.storeCreditList;
			//console.log(data.partner);
			if (data.partner) this.partner = data.partner;
			//if (this.credits.length > 0) this.selected_credit = this.credits[0];
			//console.log(this.selected_credit);

			// if (this.receiptTypes.length > 0) {
			// 	this.receipt_methods.push({ receipt_type: { code: this.receiptTypes[0].code, name: this.receiptTypes[0].name }, amount: this.totalReceiptAmount });
			// }

			if (this.totalReceiptAmount == 0 && this.receiptTypes.length > 0 && this.user.company_id == 'beautyplus') {
				var credit_rt = this.receiptTypes.filter(rt => rt.code == 'U8')[0];
				if (credit_rt) {
					this.receipt_methods.push({ receipt_type: { code: credit_rt.code, name: credit_rt.name }, amount: this.totalReceiptAmount });
					return;
				}
			}

			this.receipt_methods.push({ receipt_type: { code: null, name: '' }, amount: this.totalReceiptAmount });

			this.$nextTick(() => {
				// console.log(this.receipt_methods);
				// console.log(this.receipt_methods.length);
				//console.log(this.$refs.receipt_type_select[0]);
				this.$refs.receipt_type_select[0].focus();
				// this.$refs.receipt_type_select[0].setAttribute('aria-expanded', 'true');
				// const event = new KeyboardEvent('keydown', {
				// 	keyCode: 32, // ASCII for 'a'
				// 	ctrlKey: false, // Simulate Ctrl key being pressed
				// });
				// this.$refs.receipt_type_select[0].dispatchEvent(event);
			});
		},
	},
	created() {
		//console.log(this.toReceiveInvoices);
		const first_invoice_with_bill_to = this.toReceiveInvoices.filter(i => i.bill_to_code)[0];
		if (first_invoice_with_bill_to) this.first_bill_to_code = first_invoice_with_bill_to.bill_to_code;

		this.receipt_methods = [];

		this.init();

		//this.search();
		//console.log(this.totalReceiptAmount, this.toReceiveInvoices);
	},
	mounted() {
		inputSelectOnClick();

		// setTimeout(() => {
		// 	//this.$refs.spkeyword.focus();
		// 	if (this.receiptTypes.length > 0) {
		// 		this.receipt_methods.push({ receipt_type_code: this.receiptTypes[0].code });
		// 		console.log(this.receipt_methods);
		// 	}
		// 	//this.receipt_methods.push({receiptTypes[0]})
		// }, 10);
	},
};
</script>

<style></style>
